import axiosPlataformaClient from '../../plugins/axios.plataforma.plugin';

export default {
  getAll() {
    return axiosPlataformaClient.custAxios().get('academic/terms');
  },
  create({ termId, languageId, name }) {
    return axiosPlataformaClient.custAxios().post('academic/terms', {
      termId,
      languageId,
      name
    });
  },
  update({ customTermId, name }) {
    return axiosPlataformaClient.custAxios().put(`academic/terms/${customTermId}`, {
      name
    });
  }
};
